import {
  Grid, GridDirection, GridProps, GridSpacing, Typography,
  Skeleton } from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';
import React, { FC } from 'react';

type TitleWithValueProps = {
  title: string,
  children?: React.ReactNode,
  titleVariant?: Variant,
  direction?: GridDirection,
  justifyContent?: GridProps['justifyContent'],
  spacing?: GridSpacing,
  titleUppercase?: boolean,
  isLoading?: boolean,
  loadingRowsNumber?: number,
  loadingRowsWidth?: number | string,
  titleClassName?: string
}

export const TitleWithValue: FC<TitleWithValueProps> = ({
  title,
  children,
  titleVariant = 'caption',
  direction = 'column',
  justifyContent = 'flex-start',
  spacing = 0,
  titleUppercase = true,
  isLoading = false,
  loadingRowsNumber = 2,
  loadingRowsWidth = '100%',
  titleClassName
}) => (
  (
    <Grid
      container
      direction={direction}
      spacing={spacing}
      justifyContent={justifyContent}
    >
      <Grid item>
        <Typography variant={titleVariant} className={titleClassName} style={{ textTransform: 'capitalize' }}>
          {titleUppercase ? title.toUpperCase() : title}
        </Typography>
      </Grid>
      {children && (
        <Grid item>
          {isLoading ? (
            <>
              {Array.from(Array(loadingRowsNumber).keys()).map((i) => (<Skeleton key={i} width={loadingRowsWidth} height={30} />))}
            </>
          ) : <>{children}</>}
        </Grid>
      )}
    </Grid>
  )
);
